export default {
  //Số tiền
  CurrencyDecimalDigits: 'CurrencyDecimalDigits',
  // Đơn giá
  CurrencyUnitPriceDigits: 'CurrencyUnitPriceDigits',
  //Ngoại tệ
  AmountOCDecimalDigits: 'AmountOCDecimalDigits',
  //Tỷ giá
  ExchangeRateDecimalDigits: 'ExchangeRateDecimalDigits',
  //Hệ số, tỉ lệ
  PercentDecimalDigits: 'PercentDecimalDigits',
  //Số công
  WorkDecimalDigits: 'WorkDecimalDigits',
  //Số lượng
  NumberDecimalDigits: 'NumberDecimalDigits',

  //Không hiển thị lại lần sau: áp dụng đối với form tham số báo cáo
  IsNotShowFormNextTime: 'IsNotShowFormNextTime',
};
